import React, { useCallback, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import * as PermissionsConstants from "../../const/constants.js";
import { useHistory } from 'react-router-dom';
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  Lookup,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar,
  Item,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Editing

} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';

import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";

import "jspdf-autotable";
const inventoryOptions = [
  { id: 1, name: 'Quantity Ready to Sell' },
  { id: 2, name: 'New Production Added' },
  { id: 3, name: 'Remove Dead Quantity' },
  { id: 4, name: 'Move To Another Location' },
  { id: 5, name: 'Move From Another Location' },
  { id: 6, name: 'Change On Hand Inventory' },
];
const InventoryGrid = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  const [isMobileView, setIsMobileView] = useState(false);
  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const gridKey = "F23E6C51-1974-415F-9875-2A9AED1A5EAA";
  const [currentLayout, setCurrentLayout] = useState("Default");

  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  const updateView = () => {
    setIsMobileView(window.innerWidth <= 768);  
  };

  useEffect(() => {
    updateView();
    window.addEventListener("resize", updateView);
    return () => {
      window.removeEventListener("resize", updateView);
    };
  }, []);
  return (
    <div >
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        allowColumnReordering={true}
        allowColumnResizing={true}
        dataSource={props.data}
        showBorders={true}
        hoverStateEnabled={true}
        className={props.searchPanelStatus ? "GridHeightAccordianOpen-single-row" : "GridHeightAccordianClose"}
        remoteOperations={true}
        searchEnabled={true}
        columnAutoWidth={true}
      >
        <Editing
          mode="row"
          allowUpdating={true}
          allowAdding={true}
        />
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <Export enabled={true} allowExportSelectedData={true} />
        <Sorting visible={true} mode="multiple" />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Scrolling rowRenderingMode="virtual" />
        <Scrolling mode="standard" />
        <Column dataField="item" caption="Articulo"     hidingPriority={5} />
        <Column dataField="targetLocation" caption='Ubicación'   hidingPriority={4}   />
        <Column dataField="size" caption='Tamano'  hidingPriority={3}    />
        <Column dataField="onHand" caption='en el piso'   hidingPriority={2} />
        <Column dataField="quantity" caption='Cantidad' format={{
          type: 'fixedPoint',
          precision: 2,
          useGrouping: true
        }}    hidingPriority={1}></Column>
        <Column dataField="operations" caption='Operaciones' hidingPriority={0}>
        <Lookup
             dataSource={inventoryOptions}
             displayExpr="name"
             valueExpr="id"
         />
        </Column>
        <Toolbar>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
      </DataGrid>
    </div>
  );

};
function mapStateToProps(state) {
  return {
    oidc: state.oidc,
    ReceiptReducer: state.ReceiptReducer,
  };
}
export default connect(mapStateToProps)(InventoryGrid);